import type { Variable } from "../types";
import type {
  DocumentTemplate as ApiDocumentTemplate,
  TemplateVariable,
} from "@/queries/document-templates/document-templates.api";

// Re-export the Variable type for convenience
export type { Variable };

// Tipo local compatible con el API pero más simple para el UI
export interface DocumentTemplate {
  id: string;
  name: string; // mapped from display_name
  description: string;
  mapping_name?: string; // campo adicional del API
  variables?: TemplateVariable[]; // variables del template desde el API
  version?: number; // versión del template
}

// Función helper para convertir del API al tipo local
export const mapApiTemplateToLocal = (
  apiTemplate: ApiDocumentTemplate,
): DocumentTemplate => ({
  id: apiTemplate.id,
  name: apiTemplate.display_name,
  description: apiTemplate.description,
  mapping_name: apiTemplate.mapping_name,
  variables: apiTemplate.variables,
  version: apiTemplate.version,
});

export interface DocumentField {
  name: string;
  label: string;
  type: "text" | "number" | "date" | "boolean" | "variable";
  required: boolean;
  value: string | Variable;
  placeholder: string;
  inputType: "input" | "variable";
}

export interface DocumentGeneratorData {
  templateId: string;
  templateName: string;
  fileName: string;
  fields: DocumentField[];
  variableName: string;
}

// Mantener las plantillas hardcodeadas como fallback para desarrollo/testing
export const documentTemplates: DocumentTemplate[] = [
  {
    id: "template-1",
    name: "Informe de Proceso",
    description: "Plantilla para generar informes de procesos",
  },
  {
    id: "template-2",
    name: "Certificado de Cumplimiento",
    description: "Plantilla para certificados de cumplimiento",
  },
  {
    id: "template-3",
    name: "Reporte de Datos",
    description: "Plantilla para reportes con datos tabulares",
  },
];
